import { GadgetChannel } from "./GadgetChannel";
import { GadgetInfoTopic } from "./GadgetInfoTopic";
import { GadgetPlatformInfo } from "./GadgetPlaformInfo";
import { Box } from "@mui/material";
import { FlattenedGadget } from "../../../models/GadgetModel";
import { format, parseISO } from "date-fns";
import {
  faCalendarDays,
  faCircleUser,
  faFloppyDisk,
  faHashtag,
  faLaptop,
  faTag,
  faUser,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getGadgetSizeInMB } from "../../../helper/utils";

interface GadgetInformationDetailsProps {
  gadget: FlattenedGadget;
}

const converDateFormat = (inputDateStr: any) => {
  if (inputDateStr) {
    const inputDate = parseISO(inputDateStr);
    const formattedDate = format(inputDate, "yyyy/MM/dd HH:mm:ss");
    return formattedDate;
  }
};

export const GadgetInformationDetails = ({
  gadget,
}: GadgetInformationDetailsProps) => {
  const channels = gadget?.channels?.map((it) => it.name);
  const gadgetSize = getGadgetSizeInMB(gadget?.size);

  return (
    <Box p={1}>
      <GadgetInfoTopic
        header="Developer"
        description={gadget?.developer_name}
        icon={<FontAwesomeIcon icon={faUser} />}
        dataTestId={"gadget-developer"}
      />
      <GadgetInfoTopic
        header="Provider"
        description={gadget?.provider}
        icon={<FontAwesomeIcon icon={faCircleUser} />}
        dataTestId={"gadget-provider"}
      />
      {channels && (
        <GadgetChannel
          header="Channels"
          icon={<FontAwesomeIcon icon={faTag} />}
          channels={channels}
          dataTestId={"gadget-channels"}
        />
      )}
      {/* TODO: need to check how to fecth list of collection */}
      {/* <GadgetInfoTopic header="Collection" description="Collection Name" icon={<CollectionsBookmarkIcon className={styles.icon}/>}/> */}
      <GadgetInfoTopic
        header="Size"
        description={`${gadgetSize}MB`}
        icon={<FontAwesomeIcon icon={faFloppyDisk} />}
        dataTestId={"gadget-size"}
      />
      <GadgetInfoTopic
        header="Version"
        description={gadget?.version}
        icon={<FontAwesomeIcon icon={faHashtag} />}
        dataTestId={"gadget-version"}
      />
      <GadgetInfoTopic
        header="Last Modified"
        description={converDateFormat(gadget?.lastModifiedOn)}
        icon={<FontAwesomeIcon icon={faCalendarDays} />}
        dataTestId={"gadget-last-modified"}
      />
      <GadgetPlatformInfo
        header="Plaform"
        platform={gadget?.platform}
        icon={<FontAwesomeIcon icon={faLaptop} />}
        dataTestId={"gadget-plaform"}
      />
    </Box>
  );
};
